var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconHeartFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M13.5 4.5c-1.6.4-1.667.833-1.5 1-.52-.173-1.614-1.205-2.5-1.5-.817-.272-1.424.192-2 0C6 3.5 5 5 4.5 5.5S3 7.5 2.5 9s3.5 5 6 7.5c2 2 3.5 2.833 4 3 2-2.167 6.3-6.7 7.5-7.5 1.5-1 1-4.5 0-6.5s-4.5-1.5-6.5-1"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeLinecap: "round",
  strokeWidth: 1.4,
  d: "M11.509 5.188 12 5.67l.491-.483c2.015-1.984 5.287-1.984 7.302 0a5.004 5.004 0 0 1 0 7.158L12 20.018l-7.793-7.672-.491.498.49-.498a5.004 5.004 0 0 1 0-7.158c2.016-1.984 5.288-1.984 7.303 0Z"
})));
export { SvgIconHeartFilled as ReactComponent };